import { render } from "./error-page.vue?vue&type=template&id=5bbfa1f8&ts=true"
import script from "./error-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./error-page.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/common/error-page.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5bbfa1f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bbfa1f8', __exports__)) {
    api.reload('5bbfa1f8', __exports__)
  }
  
  module.hot.accept("./error-page.vue?vue&type=template&id=5bbfa1f8&ts=true", () => {
    api.rerender('5bbfa1f8', render)
  })

}


export default __exports__